const InquiryContentType = Symbol();

export class InquiryContent {

    [InquiryContentType]: any;
    readonly value: string;

    private constructor(
        value: string
    ) {
        this.value = value;
    }

    static fromString(value: string) {
        return new InquiryContent(value);
    }
    
}
